import React from 'react';
import ReactDOM from 'react-dom';
import BaseComponent from 'foundation/base-component';
import app, { EVENT_DEVICE_TYPE_CHANGED } from '../../../general/js/app';
import NewsFeedListing from '../../news-feed/js/news-feed-listing';
import { getPatternByDeviceType } from '../../news-feed/js/row-patterns';
import eventBus from '../../../general/js/event-bus';

class FeatureContentCopmonent extends BaseComponent {
    constructor(...args) {
        super(...args);

        this.data = this.getData();

        this.init();
    }

    static getRequiredRefs() {
        return [];
    }

    init() {
        this.render();

        eventBus.addListener(EVENT_DEVICE_TYPE_CHANGED, this.onChangeDeviceType);
    }

    getData() {
        const data = [];

        if (!Array.isArray(this.refs.row)) return data;

        this.refs.row.forEach((row) => {
            const rowData = this.getRowData(row);

            if (rowData && Array.isArray(rowData.items)) {
                const pattern = [getPatternByDeviceType(
                    rowData.patternName,
                    app.deviceTypeByViewport
                )];

                this.removeDataAttr(row);

                data.push({
                    pattern: pattern || [],
                    patternName: rowData.patternName,
                    items: rowData.items,
                    node: row
                });
            }
        });

        return data;
    }

    getRowData(row) {
        let data = null;

        try {
            data = JSON.parse(this.getAttribute(row, 'json'));
        } catch (error) {
            console.log(error);
        }

        return data;
    }

    removeDataAttr(row) {
        this.removeAttribute(row, 'json');
    }

    onChangeDeviceType = () => {
        this.updatePattern();
        this.render();
    }

    updatePattern() {
        this.data.forEach((row) => {
            row.pattern = [getPatternByDeviceType(row.patternName, app.deviceTypeByViewport)];
        });
    }

    render() {
        this.data.forEach((row) => {
            ReactDOM.render(
                <NewsFeedListing items={row.items} pattern={row.pattern}/>,
                row.node
            );
        });
    }

    onDestroy() {
        this.data.forEach((row) => {
            ReactDOM.unmountComponentAtNode(row.node);
        });
    }
}

export default FeatureContentCopmonent;
